import Vue from 'vue';
import App from './App.vue';
import router from './router';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import './styles.scss';
import VueCookies from 'vue-cookies-ts';
import VueGtag from 'vue-gtag';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtag,
    {
      config: {id: 'UA-162363845-1'},
      appName: 'Mirek Szuka Żony',
      pageTrackerScreenviewEnabled: true,
    },
    router);
}

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
